import script from "./ExpandableText.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpandableText.vue?vue&type=script&setup=true&lang=ts"

import "./ExpandableText.vue?vue&type=style&index=0&id=c1ab42ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1ab42ce"]])

export default __exports__